import { useNavigate } from "react-router-dom";

function NotFound() {
  const navigate = useNavigate();

  return (
    <section className="bg-gray-900 min-h-screen flex items-center justify-center">
      <div className="px-4 max-w-screen-sm text-center">
        <h1 className="mb-4 text-7xl tracking-tight font-extrabold lg:text-9xl text-pink-500">
          404
        </h1>
        <p className="mb-4 text-3xl tracking-tight font-bold text-white md:text-4xl">
          Página não encontrada
        </p>
        <p className="mb-4 text-lg font-light text-gray-400">
          Desculpe, não conseguimos encontrar essa página. Mas você pode voltar
          para a lista de jogos.
        </p>
        <button
          onClick={() => navigate("/lista")}
          className="inline-flex text-white bg-pink-400 hover:bg-pink-600 focus:ring-4 focus:outline-none focus:ring-pink-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:focus:ring-pink-900"
        >
          Voltar para a Lista
        </button>
      </div>
    </section>
  );
}

export default NotFound;
